import React from "react";
import { useTranslation } from "react-i18next";
import { NOTE_MAX_LENGTH } from "../../../services/bookingNotesService";

function BookingNoteComposer({
  value,
  onChange,
  onSubmit,
  disabled,
  sending,
}) {
  const { t } = useTranslation();
  const trimmed = value.trim();
  const canSend =
    !disabled && !sending && trimmed.length > 0 && value.length <= NOTE_MAX_LENGTH;

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      if (canSend) {
        onSubmit();
      }
    }
  };

  return (
    <div className="bd-notes-composer">
      <label className="bd-notes-visually-hidden" htmlFor="bd-notes-composer-input">
        {t("Add a note...")}
      </label>
      <textarea
        id="bd-notes-composer-input"
        className="bd-notes-textarea"
        rows={2}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={t("Add a note...")}
        maxLength={NOTE_MAX_LENGTH}
        disabled={disabled || sending}
      />
      <div className="bd-notes-composer-footer">
        <span
          className={`bd-notes-counter${
            value.length >= NOTE_MAX_LENGTH ? " bd-notes-counter-limit" : ""
          }`}
        >
          {value.length}/{NOTE_MAX_LENGTH}
        </span>
        <button
          type="button"
          className="bd-notes-send-btn"
          onClick={onSubmit}
          disabled={!canSend}
          aria-label={t("Send")}
        >
          <span>{t("Send")}</span>
          <i className="fas fa-paper-plane" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
}

export default BookingNoteComposer;
